import { OAuthApi, SessionApi } from '@backstage/core-plugin-api';

type GithubAuthorization = Pick<OAuthApi, 'getAccessToken'> &
  Pick<SessionApi, 'signOut'>;

type ScopeRequest = (
  url: string,
  options: RequestInit,
) => Promise<Pick<Response, 'ok' | 'headers'>>;

async function hasRepositoryScope(
  token: string,
  request: ScopeRequest,
): Promise<boolean> {
  const response = await request('https://api.github.com/user', {
    headers: {
      Accept: 'application/vnd.github+json',
      Authorization: `Bearer ${token}`,
    },
    redirect: 'error',
    credentials: 'omit',
  });

  if (!response.ok) {
    throw new Error('Não foi possível validar a autorização do GitHub.');
  }

  return (response.headers.get('x-oauth-scopes') ?? '')
    .split(/[\s,]+/)
    .includes('repo');
}

export async function requestPersonalCreationToken(
  githubAuth: GithubAuthorization,
  request: ScopeRequest = fetch,
): Promise<string> {
  let token = await githubAuth.getAccessToken('repo', { instantPopup: true });
  if (token && (await hasRepositoryScope(token, request))) {
    return token;
  }

  // A persisted Backstage session can claim scopes no longer granted by GitHub.
  // Clear that session so the next request goes through GitHub consent again.
  await githubAuth.signOut();
  token = await githubAuth.getAccessToken('repo', { instantPopup: true });
  if (!token || !(await hasRepositoryScope(token, request))) {
    throw new Error(
      'O GitHub não concedeu o escopo repo. Autorize o acesso a repositórios privados para publicar na sua conta.',
    );
  }

  return token;
}
